import Cookies from 'js-cookie';

export default class AVGController {
	constructor() {
		this.avgPermissionsCookie = Cookies.get('AVGPermissions') ? JSON.parse(Cookies.get('AVGPermissions')) : undefined;
		this.cookieBar = document.querySelector('#cookieBar');
		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push({
			"event": "ChangeCookieChoices",
			"Analytics": this.AcceptedAnalyticsCookies,
			"Tracking": this.AcceptedTrackingCookies
		});
		if (document.querySelector('form#cookieConfigure') !== null) {
			document.querySelector('input#Analytics').checked = this.AcceptedAnalyticsCookies;
			document.querySelector('input#Tracking').checked = this.AcceptedTrackingCookies;
		}

		this.LoadAVGScripts();
		this.CheckOpen();
		this.SetupButtonClicks();
	}

	get AcceptedFunctionalCookies() {
		if (this.avgPermissionsCookie === undefined) return false;

		return this.avgPermissionsCookie.Functional;
	}

	get AcceptedAnalyticsCookies() {
		if (this.avgPermissionsCookie === undefined) return true;

		return this.avgPermissionsCookie.Analytics;
	}

	get AcceptedTrackingCookies() {
		if (this.avgPermissionsCookie === undefined) return false;

		return this.avgPermissionsCookie.Tracking;
	}

	SetOrUpdatePermissionsCookie(functional, analytics, tracking) {
		this.avgPermissionsCookie = {
			Functional: functional,
			Analytics: analytics,
			Tracking: tracking
		};

		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push({
			"Analytics": this.AcceptedAnalyticsCookies,
			"Tracking": this.AcceptedTrackingCookies,
			"event": "ChangeCookieChoices"
		});

		Cookies.set('AVGPermissions', JSON.stringify(this.avgPermissionsCookie), {
			expires: 99999
		});
		this.CheckOpen();
	}

	SetupButtonClicks() {
		if (document.querySelector('a.button.agreeCookies')) {
			document.querySelectorAll('a.button.agreeCookies').forEach(agreeButton => agreeButton.addEventListener('click', this.AgreeCookies.bind(this)));
			if (document.querySelector('form#cookieConfigure') !== null) {
				document.querySelector('form#cookieConfigure').addEventListener('submit', (event) => {
					event.preventDefault();
					this.SavePreferences();
				});
			}
		}

		if (document.querySelector('#cookieBar a.goConfigure')) {
			const configureButton = document.querySelector('#cookieBar a.goConfigure');

			configureButton.addEventListener('mouseenter', () => this.LoadConfigurationForm());
			configureButton.addEventListener('click', e => {
				e.preventDefault();
				this.OpenConfigurationModal()
			});
		}

		if (document.querySelector('a.button.disagreeCookies')) {
			document.querySelector('a.button.disagreeCookies').addEventListener('click', this.DisagreeCookies.bind(this));
			if (document.querySelector('form#cookieConfigure') !== null) {
				document.querySelector('form#cookieConfigure').addEventListener('submit', (event) => {
					event.preventDefault();
					this.SavePreferences();
				});
			}
		}
	}

	LoadAVGScripts() {
		document.querySelectorAll('noscript[data-gtm-tag]').forEach(noscript => {
			this.LoadGoogleTagManager(noscript.dataset.gtmTag);
		});
	}

	LoadGoogleTagManager(gtmcode) {
		(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({
				'gtm.start': new Date().getTime(),
				event: 'gtm.js'
			});
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != 'dataLayer' ? '&l=' + l : '';
			j.async = true;
			j.src =
				'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
			f.parentNode.insertBefore(j, f);
		})
		(window, document, 'script', 'dataLayer', gtmcode);
	}

	AgreeCookies() {
		this.SetOrUpdatePermissionsCookie(true, true, true);
	}

	DisagreeCookies() {
		this.SetOrUpdatePermissionsCookie(true, true, false);
	}

	CheckOpen() {
		if (this.cookieBar != null) {
			if (this.avgPermissionsCookie === undefined) {
				if (document.querySelector('#cookieBar a.button.goConfigure').href !== document.location.toString()) {
					this.cookieBar.classList.add('open');

					setTimeout(() => {
						this.LoadConfigurationForm();
					}, 500);
				}
			} else {
				this.cookieBar.classList.remove('open');
			}
		}
	}

	SavePreferences() {
		this.SetOrUpdatePermissionsCookie(document.getElementById("Functional").checked, document.getElementById("Analytics").checked, document.getElementById("Tracking").checked);
		let saveConfirmation = document.querySelector('form#cookieConfigure .onSaveComplete');
		if (saveConfirmation !== null) {
			saveConfirmation.classList.add('success');
			setTimeout(function () {
				saveConfirmation.classList.remove('success');
			}, 1500);
		}
	}

	LoadConfigurationForm() {
		if (this.ConfigPromise) {
			return this.ConfigPromise;
		}

		const target = document.querySelector('#cookieBar a.goConfigure').href;

		this.ConfigPromise = fetch(target).then(response => {
			return response.text();
		}).then(html => {
			const parser = new DOMParser();
			const DOM = parser.parseFromString(html, 'text/html');

			if (DOM.querySelector('header .image img')) {
				return new Promise(resolve => {
					let tempImg = new Image();
					tempImg.onload = resolve.bind(this, DOM);
					tempImg.onerror = resolve.bind(this, DOM);
					tempImg.src = DOM.querySelector('header .image img').src;
				});
			}

			if (DOM.querySelector('form#cookieConfigure')) {
				return DOM.querySelector('form#cookieConfigure');
			} else {
				throw new Error('Configuration form not found');
			}
		});

		return this.ConfigPromise;
	}

	OpenConfigurationModal() {
		this.LoadConfigurationForm().then(form => {
			const modal = document.createElement('div');
			modal.id = "cookieModal";
			modal.innerHTML = `<div class="modal forceAnimations">
				<div class="modalHeader">
					<h2>Cookie instellingen</h2>
					<button class="closeModal">
						<span></span>
						<span></span>
					</button>
				</div>
				<div class="container">
					<div class="row">
						<div class="infoColumn">
							<p>Hier kan in principe heel veel tekst staan omdat je nu aaaaalle ruimte hebt die je maar zou willen. Dit omdat het een modal is</p>
						</div>
						<div class="col-12 col-md-6 formColumn"></div>
					</div>
				</div>
			</div>`;
			modal.querySelector('.formColumn').appendChild(form);

			form.addEventListener('submit', event => {
				event.preventDefault();
				this.SavePreferences();
				this.closeConfigurationModal();
			});

			const closePopup = () => {
				if (document.querySelector('#cookieModal')) {
					document.querySelector('#cookieModal').remove();
				}
			}

			window.addEventListener('keydown', e => {
				if (e.key.toLowerCase().substr(0, 3) == 'esc') {
					closePopup();
				}
			});

			modal.querySelector('.closeModal').addEventListener('click', e => {
				e.preventDefault();
				closePopup();
			});

			modal.addEventListener('click', e => {
				if (e.target.contains(modal.querySelector('.modal'))) {
					e.preventDefault();
					closePopup();
				}
			});

			if (document.querySelector('main')) {
				document.querySelector('main').appendChild(modal);
			} else {
				document.body.appendChild(modal);
			}
		});
	}

	closeConfigurationModal() {
		const modal = document.getElementById('cookieModal');
		if (modal) {
			setTimeout(() => {
				if (modal) {
					modal.classList.add('closing');
				}

				setTimeout(() => {
					if (modal && modal.parentElement) {
						modal.parentElement.removeChild(modal);
					}
				}, 500);
			}, 1000);
		}
	}
}